import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Reveal, Overline } from '../components/motion';
import { useSEO } from '../components/SEO';

export default function LegalPage({ pageKey }) {
  const { t } = useLanguage();
  const lp = t(`legal.${pageKey}`);
  useSEO('legal');

  useEffect(() => {
    document.title = `${lp.title} — Domidoor Solutions`;
  }, [lp.title]);

  return (
    <main data-testid={`legal-page-${pageKey}`} className="pt-36 lg:pt-44 pb-24">
      <div className="max-w-[860px] mx-auto px-6 md:px-12">
        <Reveal>
          <Overline className="mb-4">{t('legal.title')}</Overline>
          <h1 className="font-display text-3xl md:text-5xl font-medium tracking-tight mb-4">{lp.title}</h1>
          <p className="text-smoke text-sm mb-10">{t('legal.updated')}</p>
          <p className="text-base md:text-lg leading-relaxed text-ink/80 mb-12 border-l-2 border-accent pl-5">{lp.intro}</p>
        </Reveal>
        <div className="space-y-10">
          {lp.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <section data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-lg md:text-xl font-medium mb-3 flex items-center gap-3">
                  <span className="text-accent text-sm font-bold">0{i + 1}</span> {s.h}
                </h2>
                <p className="text-smoke leading-relaxed pl-8">{s.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14">
          <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent hover:gap-4 transition-all duration-300">
            <ArrowLeft size={14} /> {t('nav.home')}
          </Link>
        </Reveal>
      </div>
    </main>
  );
}
